document.write(
  '<link rel="stylesheet" href="http://at.alicdn.com/t/font_2291253_33hit8qj0q4.css" type="text/css">'
);
import FormMaking from "./assets/lib/vue-form-making";
import "./assets/lib/vue-form-making/dist/FormMaking.css";
import WorkFlow from "./views/admin";
import FormControls from "./components/FormControls/index.js";
import axios from "@/utils/axios";
import _ from "lodash";
import Flag from "./components/DynamicForm/components/flag"; // 审核结果
import Remark from "./components/DynamicForm/components/remark"; // 审核意见
import UploadFile from "./components/DynamicForm/components/uploadFile"; // 附件
import UploadImage from "./components/DynamicForm/components/uploadImage"; // 图片
import AreaSelect from "./components/DynamicForm/components/areaSelect"; // 省市区
import Contacts from "./components/DynamicForm/components/contacts"; // 联系人
import Company from "./components/DynamicForm/components/company"; // 所属公司
import CompanyDepartments from "./components/DynamicForm/components/companyDepartments"; // 所属公司及部门
import SelectUser from "./components/DynamicForm/components/selectUser"; // 人员选择
window._ = _;

const components = {
  WorkFlow
};
const install = function(Vue, opts = {}) {
  if (install.installed) return;

  Vue.prototype.$axios = axios;
  Vue.prototype._ = _;

  Object.keys(components).forEach(key => {
    Vue.component(key, components[key]);
  });

  Vue.use(FormControls);
  Vue.use(FormMaking, {
    components: [
      {
        name: "flag", // 审核结果
        component: Flag
      },
      {
        name: "remark", // 审核意见
        component: Remark
      },
      {
        name: "uploadFile", // 附件
        component: UploadFile
      },
      {
        name: "uploadImage", // 图片
        component: UploadImage
      },
      {
        name: "areaSelect", // 省市区
        component: AreaSelect
      },
      {
        name: "contacts", // 联系人
        component: Contacts
      },
      {
        name: "company", // 所属公司
        component: Company
      },
      {
        name: "companyDepartments", // 所属公司及部门
        component: CompanyDepartments
      },
      {
        name: "selectUser", // 人员选择
        component: SelectUser
      }
    ]
  });
};

// auto install
if (typeof window !== "undefined" && window.Vue) {
  install(window.Vue);
}

const API = {
  version: process.env.VERSION,
  install,
  ...components
};

export { install, WorkFlow };

export default {
  install,
  WorkFlow
};
